import { render, staticRenderFns } from "./OrdonnanceRenameForm.vue?vue&type=template&id=30398b56&"
import script from "./OrdonnanceRenameForm.vue?vue&type=script&lang=js&"
export * from "./OrdonnanceRenameForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports